import React, { useState, useMemo } from "react";
import Style from "../style/bloglandingleft.module.scss";

import { useNavigate } from "react-router-dom";

interface IType {
  details: any;
  recent_blogs: any;
  userId: any;
  userTitle: any;
}

const BlogLandingLeft: React.FC<IType> = ({
  details,
  recent_blogs,
  userId,
  userTitle,
}) => {
  const navigate = useNavigate();
  const [hasClickedNext, setHasClickedNext] = useState(false);
  const baseUrl = "https://backend.onedialusa.com/assets/img/blogs/";

  const allBlogs = useMemo(() => {
    const merged = [details, ...recent_blogs];
    return merged.filter(
      (blog, index, self) =>
        blog && self.findIndex((b: any) => b.id === blog.id) === index
    );
  }, [details, recent_blogs]);

  const currentIndex = useMemo(() => {
    return allBlogs.findIndex((item) => item?.id === Number(userId));
  }, [allBlogs, userId]);

  const prevBlog = allBlogs[currentIndex - 1];
  const nextBlog = allBlogs[currentIndex + 1];

  const handleNavigation = (blog: any, direction: "next" | "previous") => {
    if (!blog) return;
    navigate(
      `/blog/${blog.title.toLowerCase().replaceAll(" ", "-")}/${blog.id}`
    );
    if (direction === "next") {
      setHasClickedNext(true);
    } else if (direction === "previous") {
      setHasClickedNext(false);
    }
  };
  return (
    <div className={Style.leftAside}>
      <span>
        <img
          src={`${baseUrl}${details?.image}`}
          onError={(e: any) => {
            e.target.src =
              "https://images.unsplash.com/photo-1499750310107-5fef28a66643?fm=jpg&q=60&w=3000";
          }}
          alt={details?.title}
          loading="lazy"
          width="100%"
          height="auto"
          style={{ objectFit: "cover" }}
        />
      </span>

      <div className={Style.detail}>
        <ul>
          <li>
            <i className="fa-solid fa-user"></i> Admin
          </li>
          <li>
            <i className="fa-solid fa-calendar"></i> {details?.created_at}
          </li>
          <li>
            <i className="fa-solid fa-tag"></i> {details?.categoryName}
          </li>
        </ul>
      </div>

      <div className={Style.fullData}>
        <div className={Style.shareContainer}>
          <button
            className={Style.prevNext}
            onClick={() => handleNavigation(prevBlog, "previous")}
            disabled={currentIndex === 0 && !hasClickedNext}
            style={{
              opacity: currentIndex > 0 || hasClickedNext ? 1 : 0.5,
              cursor:
                currentIndex > 0 || hasClickedNext ? "pointer" : "not-allowed",
            }}
          >
            ← Previous
          </button>

          <div className={Style.shareIcons}>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                alt="Facebook"
              />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/3256/3256013.png"
                alt="Twitter"
              />
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                alt="LinkedIn"
              />
            </a>
            <a
              href={`https://api.whatsapp.com/send?text=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/2504/2504957.png"
                alt="WhatsApp"
              />
            </a>
          </div>
          <button
            className={Style.prevNext}
            onClick={() => handleNavigation(nextBlog, "next")}
            disabled={currentIndex === allBlogs.length - 1}
            style={{
              opacity: currentIndex < allBlogs.length - 1 ? 1 : 0.5,
              cursor:
                currentIndex < allBlogs.length - 1 ? "pointer" : "not-allowed",
            }}
          >
            Next →
          </button>
        </div>
      </div>

      <div
        className={Style.Description}
        dangerouslySetInnerHTML={{
          __html: details?.content || "",
        }}
      />
      <div className={Style.fullData}>
        <div className={Style.shareContainer}>
          <button
            className={Style.prevNext}
            onClick={() => handleNavigation(prevBlog, "previous")}
            disabled={currentIndex === 0 && !hasClickedNext}
            style={{
              opacity: currentIndex > 0 || hasClickedNext ? 1 : 0.5,
              cursor:
                currentIndex > 0 || hasClickedNext ? "pointer" : "not-allowed",
            }}
          >
            ← Previous
          </button>

          <div className={Style.shareIcons}>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                alt="Facebook"
              />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/3256/3256013.png"
                alt="Twitter"
              />
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                alt="LinkedIn"
              />
            </a>
            <a
              href={`https://api.whatsapp.com/send?text=https://onedialusa.com/blog/${userTitle}/${userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/2504/2504957.png"
                alt="WhatsApp"
              />
            </a>
          </div>
          <button
            className={Style.prevNext}
            onClick={() => handleNavigation(nextBlog, "next")}
            disabled={currentIndex === allBlogs.length - 1}
            style={{
              opacity: currentIndex < allBlogs.length - 1 ? 1 : 0.5,
              cursor:
                currentIndex < allBlogs.length - 1 ? "pointer" : "not-allowed",
            }}
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogLandingLeft;
